import { Field, useFormikContext } from 'formik';
import ErrorShow from './ErrorShow';
import './fields.css';
import { FormLabel } from './FormLable/FormLabel';
import React, { useEffect } from 'react';

export const GenericInputField = ({
  name,
  type = 'text',
  placeholder,
  label,
  inputValue,
  errors = {},
  touched = {},
  className,
  twoItemInOneRow = false,
  isDisabled = false,
  centerAlign = false,
  spacing = 'normal',
  numericKeyboard = false,
  onBlur, // اضافه کردن onBlur prop
  maxLength, // اضافه کردن maxLength prop
  ...fieldProps
}) => {
  const { setFieldValue, setFieldError, setFieldTouched } = useFormikContext();
  const shouldDisable = Boolean(inputValue) || isDisabled;
  const hasError = errors[name] && touched[name];

  // کلاس‌های فاصله‌گذاری
  const spacingClass =
    {
      tight: 'spacing-tight',
      normal: 'spacing-normal',
      wide: 'horizontal-spacing-wide',
    }[spacing] || 'spacing-normal';

  const fieldClassName = `form-control noFocusStyle ${className} ${hasError && !shouldDisable ? 'is-invalid' : ''}`;

  // تعیین inputMode و pattern برای کیبورد عددی
  const getInputProps = () => {
    const props = {};

    if (numericKeyboard || type === 'number' || name === 'code') {
      props.inputMode = 'numeric';
      props.pattern = '[0-9]*';
    }

    if (maxLength) {
      props.maxLength = maxLength;
    }

    return props;
  };

  useEffect(() => {
    if (inputValue !== undefined && inputValue !== null && inputValue !== '') {
      setFieldValue(name, inputValue);
      setFieldTouched(name, true);
      setFieldError(name, '');
    }
  }, [inputValue, name, setFieldValue, setFieldTouched, setFieldError]);

  return (
    <div className={`form-group`}>
      <FormLabel name={name} label={label} />
      <div className={`${centerAlign ? 'center-align' : ''}`}>
        <Field
          dir='rtl'
          disabled={shouldDisable}
          type={type}
          name={name}
          className={`${fieldClassName} ${spacingClass}`}
          placeholder={inputValue || placeholder}
          onBlur={(e) => {
            // اول blur اصلی formik را اجرا کن
            e.persist();
            setFieldTouched(name, true);

            // سپس onBlur کاستوم را اجرا کن
            if (onBlur && typeof onBlur === 'function') {
              onBlur(e);
            }
          }}
          {...getInputProps()}
          {...fieldProps}
        />
      </div>
      {!shouldDisable && <ErrorShow errors={errors} touched={touched} name={name} />}
    </div>
  );
};
